import React, { useState } from 'react'

import HeaderCell from 'components/Table/HeaderCell'
import FilterDropdown from 'pages/DeviceAggregator/FaceplateMessages/FilterDropdown'
import styled from 'styled-components'

type Props = {
  filterOptions: Array<string>
  selectedFilterOptions: Array<string>
  onChangeFilterOptionsCallback: (selectedOptions: Array<string>) => void
}

const EventNameColumnHeader = ({ filterOptions, selectedFilterOptions, onChangeFilterOptionsCallback }: Props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  return (
    <S.Header>
      <HeaderCell
        title="Event Name"
        enableFilter
        anyFilterSelected={selectedFilterOptions.length !== filterOptions.length}
        onClickFilterIcon={() => setIsDropdownOpen((oldIsDropdownOpen) => !oldIsDropdownOpen)}
      />
      <S.FilterDropdown
        isDropdownOpen={isDropdownOpen}
        onCloseDropdown={() => setIsDropdownOpen(false)}
        options={filterOptions}
        selectedFilterOptions={selectedFilterOptions}
        onChangeFilterOptionsCallback={onChangeFilterOptionsCallback}
      />
    </S.Header>
  )
}

export default EventNameColumnHeader

const S = {
  Header: styled.div`
    display: flex;
    flex: 1;
    position: relative;
  `,
  FilterDropdown: styled(FilterDropdown)`
    top: 100%;
    left: calc(100% - 30px);
  `
}
